import { CampaignMonitoring } from '../../pages';
import { MessagesForContact } from '../../pages';
import { PromptsForCampaign } from '../../pages';
import { Contacts, ContactsImport } from '../../pages';
import { Tasks, Campaigns, GeneralMonitoring } from '../../pages';
// import { Statistics, Webhooks } from '../../pages';

const mainMenuRoutes: AppRouteType[] = [
  {
    icon: 'list',
    url: '/tasks',
    menuTitle: 'Tasks',
    pageTitle: 'Tasks Management',
    action: 'view_outreach_contacts',

    component: Tasks,
  },
  {
    url: '/campaign_monitoring/:id',
    pageTitle: 'Campaign Monitoring',
    action: 'view_outreach_campaigns',

    component: CampaignMonitoring,
  },
  {
    icon: 'rocket',
    url: '/campaigns',
    menuTitle: 'Campaigns',
    pageTitle: 'Campaigns Management',
    action: 'view_outreach_campaigns',

    component: Campaigns,
  },
  {
    icon: 'eye',
    menuTitle: 'Monitoring',
    pageTitle: 'Campaign Monitoring',
    url: '/campaign_monitoring',
    action: 'view_outreach_campaigns',

    component: GeneralMonitoring,
  },
  {
    icon: 'people',
    url: '/contacts_management',
    menuTitle: 'Contacts',
    pageTitle: 'Contacts Management',
    action: 'view_outreach_contacts',

    component: Contacts,
  },
  {
    icon: 'plus',
    url: '/contacts_import',
    menuTitle: 'Import Contacts',
    action: 'manage_outreach_contacts',

    component: ContactsImport,
  },
  {
    url: '/contacts_management/messages_history/:id',
    pageTitle: 'Messages History',
    action: 'view_outreach_contacts',

    component: MessagesForContact,
  },
  {
    url: '/campaigns/system_prompts/:id',
    pageTitle: 'System Prompts List',
    action: 'view_outreach_campaigns',

    component: PromptsForCampaign,
  },

  // {
  //   icon: 'hook',
  //   url: '/webhook_events',
  //   menuTitle: 'Webhook Events',
  //   action: 'view_outreach_contacts',

  //   component: Webhooks,
  // },
  // {
  //   icon: 'chart',
  //   url: '/system_statistics',
  //   menuTitle: 'Statistics',
  //   pageTitle: 'System Statistics',
  //   action: 'view_outreach_campaigns',

  //   component: Statistics,
  // },
];

export const getRoutes: (meta: AppMetaType) => AppRouteType[] = _meta => {
  return mainMenuRoutes;

  // return [
  //   {
  //     groupTitle: 'Main Menu',
  //     routes: mainMenuRoutes,
  //   },
  // ];
};
